import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import _ from 'lodash'
import 'react-vis/dist/style.css'
import {
    XYPlot,
    XAxis,
    YAxis,
    HorizontalGridLines,
    VerticalGridLines,
    VerticalBarSeries,
} from 'react-vis';
import {api_base_url} from "../../settings";
import {sort_order} from "../../utils";
class DatasetAvailabilityChart extends Component{
    state = {
        width: 450
    };
    settings = {
        maxWidth: 700,
        height: 400,
        title: "Dataset Availability Overview",
        chartSeries: [{field: 'count', name: 'Count'}],
        x: 'label',
        y: 'count',
        label: 'label',
        dataset: 'datatype',
        xScale: 'ordinal',
        xLabel: 'Datasets',
        yLabel: 'Number of Models',
    };
    componentDidMount(){
        fetch(api_base_url + "/availability_data")
            .then(resp => resp.json())
            .then(items => _.sortBy(items, (item) => sort_order(item.label)))
            .then(resp => {
                let result = resp.map((item, i) => {
                    return {
                        x: item[this.settings.x],
                        y: item[this.settings.y],
                        label: item[this.settings.label],
                        dataset: item[this.settings.dataset],
                        color: i + ""
                    }
                });
                this.setState({data: result})
            })
            .catch(error => console.error(error))

        this.updateWidth();

        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => this.updateWidth());
            this.resizeObserver.observe(this.container);
        } else {
            // Fallback for browsers without ResizeObserver support.
            window.addEventListener('resize', this.updateWidth);
        }
    }
    componentDidUpdate(){
    }
    componentWillUnmount(){
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        } else {
            window.removeEventListener('resize', this.updateWidth);
        }
    }
    updateWidth = () => {
        if (!this.container) {
            return;
        }
        const containerWidth = this.container.getBoundingClientRect().width;
        const width = Math.min(
            this.settings.maxWidth,
            Math.max(containerWidth, 280)
        );
        if (width !== this.state.width) {
            this.setState({width});
        }
    };
    handleClick = (source) =>{
        this.props.history.push("/passports?datasets=" + source.dataset)
        window.scrollTo(0,0)
    };
    handleMouseOver = (source) => {
        this.setState({hovered: source.x})
    };
    render() {
        return(
            <div ref={node => this.container = node} className="dataset-availability-chart">
                <style>{`
                    .dataset-availability-chart .rv-xy-plot__axis--horizontal .rv-xy-plot__axis__tick__text {
                        transform: translate(0px, 14px) rotate(-35deg) !important;
                        text-anchor: end !important;
                        font-size: 0.7rem !important;
                    }
                `}</style>
                {this.state.data && (
                    <XYPlot
                        xType="ordinal"
                        width={this.state.width}
                        height={this.settings.height}
                        colorRange={["#6A2E71", "#C8B3CB"]}
                        margin={{left: 60, right: 40, top: 10, bottom: 80}}
                        style={{padding: "0 0 0 25px"}}
                    >
                        <VerticalGridLines />
                        <HorizontalGridLines />
                        <XAxis />
                        <YAxis title="Number of Models"
                               style={{title: {transform: "translate(-42px, -10px)", fontSize: "1rem", fontWeight: 400}}}/>
                        <VerticalBarSeries
                            data={this.state.data}
                            onValueClick={this.handleClick}
                            onValueMouseOver={this.handleMouseOver}
                            onValueMouseOut={() => this.setState({hovered: null})}
                            className="dataset-bar"
                        />
                    </XYPlot>
                )}
            </div>
        )
    }
}
export default withRouter(DatasetAvailabilityChart);